export default __webpack_public_path__ + "f75454b88aea0de0178f8a1e45f2928c.png";